// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { captureException } from '@sentry/react';

/**
 * Creates a zod catch function that logs errors in dev mode
 *
 * @param fallbackValue - The value to return when catching an error
 * @returns A function that can be used with zod's .catch() method
 */
export function zodCatch<T>(fallbackValue: T) {
  return (ctx: { error: unknown }) => {
    if (import.meta.env.DEV) {
      console.error('Zod validation error:', ctx.error);
    } else {
      captureException(ctx.error);
    }
    return fallbackValue;
  };
}
